import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useDrag } from 'vue3-dnd'
import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DragRow',
  props: {
    row: {},
    sourceId: {}
  },
  setup(__props: any) {

const props = __props

const rowEl = ref<HTMLElement | null>(null)

// useDrag возвращает [collectRef, drag]
const [collect, drag] = useDrag(() => ({
  type: 'ROW',
  item: { row: props.row, sourceId: props.sourceId },
  collect: (monitor) => ({
    isDragging: monitor.isDragging()
  })
}))

onMounted(() => {
  if (rowEl.value) drag(rowEl.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    style: _normalizeStyle({ visibility: _unref(collect).isDragging ? 'hidden' : 'visible', opacity: _unref(collect).isDragging ? 0.3 : 1 }),
    class: "drag-row",
    ref_key: "rowEl",
    ref: rowEl
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})